/**
 * Partner-related constants and types for the provisioning API
 */
/**
 * Partner scope keys (matches Prisma enum names)
 */
export var PartnerScopeKey;
(function (PartnerScopeKey) {
    PartnerScopeKey["PROVISIONING_READ"] = "PROVISIONING_READ";
    PartnerScopeKey["PROVISIONING_WRITE"] = "PROVISIONING_WRITE";
    PartnerScopeKey["LISTING_SETTINGS_READ"] = "LISTING_SETTINGS_READ";
    PartnerScopeKey["LISTING_SETTINGS_WRITE"] = "LISTING_SETTINGS_WRITE";
    PartnerScopeKey["SEQUENCES_WRITE"] = "SEQUENCES_WRITE";
    PartnerScopeKey["WEBHOOKS_WRITE"] = "WEBHOOKS_WRITE";
})(PartnerScopeKey || (PartnerScopeKey = {}));
/**
 * OAuth scopes that can be granted to partners (string values for JWT)
 */
export var PartnerScope;
(function (PartnerScope) {
    PartnerScope["PROVISIONING_READ"] = "provisioning:read";
    PartnerScope["PROVISIONING_WRITE"] = "provisioning:write";
    PartnerScope["LISTING_SETTINGS_READ"] = "listing-settings:read";
    PartnerScope["LISTING_SETTINGS_WRITE"] = "listing-settings:write";
    PartnerScope["SEQUENCES_WRITE"] = "sequences:write";
    PartnerScope["WEBHOOKS_WRITE"] = "webhooks:write";
})(PartnerScope || (PartnerScope = {}));
/**
 * Map Prisma scope key to OAuth scope value
 */
export const PARTNER_SCOPE_MAP = {
    [PartnerScopeKey.PROVISIONING_READ]: PartnerScope.PROVISIONING_READ,
    [PartnerScopeKey.PROVISIONING_WRITE]: PartnerScope.PROVISIONING_WRITE,
    [PartnerScopeKey.LISTING_SETTINGS_READ]: PartnerScope.LISTING_SETTINGS_READ,
    [PartnerScopeKey.LISTING_SETTINGS_WRITE]: PartnerScope.LISTING_SETTINGS_WRITE,
    [PartnerScopeKey.SEQUENCES_WRITE]: PartnerScope.SEQUENCES_WRITE,
    [PartnerScopeKey.WEBHOOKS_WRITE]: PartnerScope.WEBHOOKS_WRITE,
};
/**
 * Partner account status
 */
export var PartnerStatus;
(function (PartnerStatus) {
    PartnerStatus["ACTIVE"] = "ACTIVE";
    PartnerStatus["SUSPENDED"] = "SUSPENDED";
    PartnerStatus["REVOKED"] = "REVOKED";
})(PartnerStatus || (PartnerStatus = {}));
/**
 * All available partner scopes as an array
 */
export const ALL_PARTNER_SCOPES = Object.values(PartnerScope);
/**
 * Standard scopes granted to a fully-provisioned partner.
 * Use this as the reference when creating new partners to avoid scope drift.
 */
export const DEFAULT_PARTNER_SCOPES = [
    PartnerScope.PROVISIONING_READ,
    PartnerScope.PROVISIONING_WRITE,
    PartnerScope.LISTING_SETTINGS_READ,
    PartnerScope.LISTING_SETTINGS_WRITE,
    PartnerScope.SEQUENCES_WRITE,
    PartnerScope.WEBHOOKS_WRITE,
];
/**
 * Check if a string is a valid partner scope
 */
export function isValidPartnerScope(scope) {
    return ALL_PARTNER_SCOPES.includes(scope);
}
/**
 * Partner audit log actions for tracking provisioning events
 */
export var PartnerAuditAction;
(function (PartnerAuditAction) {
    PartnerAuditAction["PROVISION_CREATE"] = "provision.create";
    PartnerAuditAction["PROVISION_UPDATE"] = "provision.update";
    PartnerAuditAction["PROVISION_DELETE"] = "provision.delete";
    PartnerAuditAction["CREDENTIALS_GENERATE"] = "credentials.generate";
    PartnerAuditAction["CREDENTIALS_ROTATE"] = "credentials.rotate";
})(PartnerAuditAction || (PartnerAuditAction = {}));
/**
 * Partner audit log resource types
 */
export var PartnerAuditResourceType;
(function (PartnerAuditResourceType) {
    PartnerAuditResourceType["COMPANY"] = "company";
    PartnerAuditResourceType["CREDENTIALS"] = "credentials";
})(PartnerAuditResourceType || (PartnerAuditResourceType = {}));
//# sourceMappingURL=partner.js.map